export const Colors = {
  DEFAULT: "#ffc400",
  DEFAULT_DARK: "#000",
  WHITE: "#fff",

  DARK_HOVER: "rgba(255, 255, 255, 0.1)",

  ICON: "#A4AFB7",

  BACKGROUND: "#fff",
};
